import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissNumberField, CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function MotivoDevolucaoListFilter() {
    const [filterCodigo, setFilterCodigo] = useState<FilterValuesProps>({
        property: 'idMotivoDevolucao',
        operator: 'eq',
        value: '',
    });

    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsMotivoDevolucao',
        operator: 'like',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: true,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            filters={[
                { value: filterCodigo, setter: setFilterCodigo },
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissNumberField
                    label="Código"
                    value={filterCodigo.value}
                    onChange={(e) => setFilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                    preventEmptyField={false}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Título"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <StatusField
                    value={filterStatus.value}
                    onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
